import { render, staticRenderFns } from "./CustomerVerify.vue?vue&type=template&id=a0214568&scoped=true&"
import script from "./CustomerVerify.vue?vue&type=script&lang=js&"
export * from "./CustomerVerify.vue?vue&type=script&lang=js&"
import style0 from "./CustomerVerify.vue?vue&type=style&index=0&id=a0214568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0214568",
  null
  
)

export default component.exports